<i18n>
{
  "ru":{
    "payment_details": "Детали платежа"
  },
  "en":{
    "payment_details": "Payment details"
  }
}
</i18n>
<template>
  <el-dialog :close-on-click-modal="false"
    custom-class="webpay"
    :visible.sync="visibleInner"
    top="1vh"
    append-to-body
  >
    <span slot="title">
      <h4></h4>
    </span>

    <payment-details
      :visible.sync="visibleInner"
      :url="url"
      :callback="callback"
    ></payment-details>
  </el-dialog>
</template>

<script>
import PaymentDetails from './PaymentDetails'

export default {
  name: 'payment-details-modal',
  props: ['visible', 'url', 'callback'],
  components: {
    'payment-details': PaymentDetails
  },
  computed: {
    visibleInner: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  }
}
</script>
